import { type ServiceMethod } from '@/application/interfaces/service';

import { type SaleOrderData } from '../model';

export type SearchParams = {
  perPage?: number;
};
export interface Meta {
  page: number;
  perPage: number;
  totalCount: number;
  hasNextPage: boolean;
}

export interface Response {
  data: SaleOrderData[];
  meta: Meta;
}

const getSaleOrders: ServiceMethod<Response, SearchParams> =
  (httpClient) => async (data, options) => {
    const { body } = await httpClient.get<Response, undefined, SearchParams>(
      '/api/v3/sale-order',
      {
        ...options,
        searchParams: {
          ...data,
        },
      }
    );

    return body;
  };

export default getSaleOrders;
